import ReactGA from 'react-ga4';
// import { useTranslation } from 'react-i18next';
// import { useTonConnectUI, useTonWallet } from '@tonconnect/ui-react';
// import { Address } from '@ton/ton';
////////////////////////////////////////////////////////////////////
import { BackButton, PageTitle, ProductsList } from '@/app/shared/components';
import { useEffect } from 'react';
// import { useCustomSelector } from '@/core/redux/hooks';
// import { useEffect, useState } from 'react';
// import { TonService } from '@/core/services';
// import { useCustomSelector } from '@/core/redux/hooks';

/**
 * Shop page component.
 *
 * This component is responsible for rendering the shop page of the
 * application. It displays the products available in the shop.
 *
 * @returns {JSX.Element} The rendered component.
 */
const Shop: React.FC = () => {
	/*********************
	// #region GA Events
	**********************/

	/*********************
    // #region Hooks
    **********************/
	// const wallet = useTonWallet();
	// const [tonConnectUI] = useTonConnectUI();
	// const [userWalletAddr, setUserWalletAddr] = useState('');

	/*********************
	// #region Constants
	**********************/
	// const vottunWalletAddrTestnet =
	// 	'0QA9r6t7A2uVzzwWjBizqtf_kEaPl0XNwL3DNytCxzFf54Qi';
	// //TODO use usdt jetton master address
	// const paymentTokenTestnetAddr =
	// 	'kQBauG6xOOq-uIMggPKPHEbRBRn-HeD4uVF8-7TGdm016O56';

	/*********************
	// #region Observables
	**********************/
	useEffect(() => {
		ReactGA.send({
			hitType: 'pageview',
			page: '/shop',
			title: 'Shop',
		});
	}, []);

	// useEffect(() => {
	// 	if (!wallet) {
	// 		return;
	// 	}
	// 	setUserWalletAddr(
	// 		Address.parse(wallet?.account.address ?? '').toString()
	// 	);
	// }, []);

	/*********************
	// #region Functions
	**********************/
	// async function onClickBuy(productName: string, amountToPay: string) {
	// 	try {
	// 		if (userWalletAddr === '' || !wallet) {
	// 			return;
	// 		}
	// 		const currUserJettonWallet =
	// 			await TonService.getJettonWalletAddress(
	// 				paymentTokenTestnetAddr,
	// 				wallet?.account.address ?? ''
	// 			);
	// 		//prepare tx body
	// 		const transaction = TonService.getTransferJettonTxBody(
	// 			productName,
	// 			amountToPay,
	// 			vottunWalletAddrTestnet,
	// 			userWalletAddr,
	// 			currUserJettonWallet.jettonWalletAddress
	// 		);

	// 		//TODO mirar que al cambiar testonly y bounceable, el address cambia, las variantes de tipos de address
	// 		//son E...(testonly = true, bounc: false), U...(testonly = false, bounc: false),
	// 		//k...(testonly = true, bounceable = true), O...(testonly = false, bouncable = true)
	// 		//bounceable => protect users from erroneous transfers, if send tokens to erroneous address, coins will bounce back with a fee deduction
	// 		//Non-bounceable =>  wallet that receives messages and processes them without bouncing them back
	// 		//Non-bounceable wallets are used for receiving funds or executing smart contract logic.
	// 		//TODO notify inside catch error
	// 		await tonConnectUI.sendTransaction(transaction);
	// 	} catch (error) {
	// 		console.error('Error on send transaction', error);
	// 	}
	// }
	/*********************
	// #region Template
	**********************/
	return (
		<div className="flex flex-col gap-2 pt-8 pb-32 mx-4">
			<BackButton />
			<div className="flex flex-col items-center">
				<PageTitle>Shop</PageTitle>
			</div>
			<ProductsList />
		</div>
	);
};

export default Shop;
